export default "__VITE_ASSET__GvW_y$Z7__"